__turbopack_context__.v({
  "salary-time": "N7GzvG_salary-time",
  "salary-title": "N7GzvG_salary-title",
  "slider": "N7GzvG_slider",
  "slider-mark": "N7GzvG_slider-mark",
  "slider-thumb": "N7GzvG_slider-thumb",
  "slider-value": "N7GzvG_slider-value",
  "slider-wrapper": "N7GzvG_slider-wrapper",
});
